export enum DashboardTypeE {
  TRANSPORT = 'Transport',
}

export enum TransportTypeCustomersE {
  SAINT_LUCIA_NATIONAL_CONSERVATION_FUND = '4042dbe6-1eca-4de8-b70b-f4502bcabcd6',
  WAYAJ_EARTH_FRIENDLY_TRAVEL = '9a5e90ac-ce29-47a4-a6a9-0605f37a852b',
  INTER_AMERICAN_INSTITUTE_FOR_COOPERATION = '83dfaf52-8f2e-4f0e-9166-6749327edb3d',
  OCEANIC_GLOBAL = 'd1040698-7f02-4b4c-830f-d9af6aff281e',
  SURETRAVEL = '50fb779b-c0e8-4dee-b69c-d77e53a8ce29',
  ETRAVEL = '13de2937-8d20-409f-96f4-3997a3acf8d1',
}

export enum CalculatorTypeE {
  HOTEL = 'hotel',
  TRANSPORT = 'transport',
  HOTEL_AND_TRANSPORT = 'hotelAndTransport',
}

export enum CarbonOffsetEquivalentE {
  PLASTIC_BOTTLE,
  PLASTIC_STRAW,
  PLASTIC_KEY_CARD,
  WASHED_TOWEL,
}

export enum TransportTypesE {
  CAR = 'CAR',
  PLANE = 'PLANE',
  BUS = 'BUS',
  TRAIN = 'TRAIN',
  BOAT = 'BOAT',
}

export enum CustomersWithCustomElementsE {
  ILHA_DE_TOQUE_ECO_BOTIQUE_HOTEL_SAO_SEBASTIAO = 'ilha-de-toque-toque-eco-boutique-hotel-sao-sebastiao',
  MURAL_TO = 'muralto-madrid-princesa',
  SIX_SENSES_DOURO_VALLEY_SAMODAES = 'six-senses-douro-valley-samodaes',
  WAYAJ_EARTH_FRIENDLY_TRAVEL = 'wayaj-earth-friendly-travel',
  BAHIA_MAR_BOTIQUE = 'bahia-mar-boutique-hotel',
  MONDI_LODGE = 'mondi-lodge',
  THE_MERCHANT_HOUSE = 'the-merchant-house',
  TAMARIND_TREE_DOMINICA = 'tamarind-tree-dominica',
  INTER_AMERICAN_INSTITUTE_FOR_COOPERATION = 'inter-american-institute-for-cooperation',
}
